// src/Components/Auth/ProtectedRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withAuth } from "./WithAuth";

// Props: component = the component to render, ...rest = all other Route props
const ProtectedRoute = ({ component: Component, auth, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        auth.authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
  );
};

export default withAuth(ProtectedRoute);


// WEBPACK FOOTER //
// ./src/Components/Auth/ProtectedRoute.js